import React, { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import he from 'he';
import * as lib from '~/dependencies';
import * as actions from '~/store/actions';
import * as Loaders from '~/components/Loaders';
import { formatCallDate } from '~/helpers';
import { Container, RowNotes, NotesContainer, Title } from './styles';

export default function ShowNotes({ callId, sipCallId, originalSipCallId }) {
  // SELECTORS
  const loading = useSelector(state => state.draft?.loading);
  const allNotes = useSelector(state => state.draft?.notes);
  const userTz = useSelector(state => state.auth?.userTimeZone);
  // MEMOs
  const callIdMemo = useMemo(() => callId, [callId]);

  // HOOKS
  const dispatch = useDispatch();
  const { t } = lib.useTranslation();

  const callNotes = allNotes?.filter(e => e.call_id === callIdMemo)?.reverse();

  // EFFECTS
  useEffect(() => {
    if (callIdMemo) {
      const standardCallId = String(callIdMemo?.raw || callIdMemo).replaceAll(
        '*',
        '.'
      );

      dispatch(
        actions.getNotesByCallId(standardCallId, sipCallId, originalSipCallId)
      );
    }
  }, [dispatch, callIdMemo, sipCallId, originalSipCallId]);

  return (
    <Container className="showNotes">
      {loading ? (
        <div className="note-clickable">
          <Title>{t('components.showNotes.title')}</Title>
          <Loaders.Line size="290" />
        </div>
      ) : (
        <>
          {callNotes && (
            <>
              {callNotes.length > 0 && (
                <span className="title">{t('components.showNotes.title')}</span>
              )}
              <NotesContainer>
                {callNotes.map(e => (
                  <RowNotes key={Math.random()}>
                    <div className="message">
                      <p>{he.decode(e.note || '')}</p>
                    </div>
                    <div className="informations">
                      <span>{e.user_name}</span>
                      <span>-</span>
                      <div className="grouped">
                        <span>
                          {formatCallDate(
                            e.note_time,
                            'DD MMM YYYY HH:mm',
                            userTz
                          )}
                        </span>
                      </div>
                    </div>
                  </RowNotes>
                ))}
              </NotesContainer>
            </>
          )}
        </>
      )}
    </Container>
  );
}

ShowNotes.defaultProps = {
  callId: null,
  sipCallId: null,
  originalSipCallId: null,
};

ShowNotes.propTypes = {
  callId: lib.PropTypes.string,
  sipCallId: lib.PropTypes.string,
  originalSipCallId: lib.PropTypes.string,
};
